import React from "react";
import styles from "./contact-queries-drawer.module.css";
import CustomDrawer from "../../../../common/custom-drawer/custom-drawer";
import { Col, Row } from "antd";
import dayjs from "dayjs";
import { DATE_FORMAT } from "../../../../constants/common";

const ContactQueriesDrawer = ({
  open,
  onClose,
  viewDetailsInfo
}) => {
  const details = [
    { label: "Full Name", value: viewDetailsInfo?.name },
    { label: "Email Address", value: viewDetailsInfo?.email },
    { label: "Phone Number", value: viewDetailsInfo?.phone_number },
    { label: "School / Organization Name", value: viewDetailsInfo?.institution_name },
    { label: "Message", value: viewDetailsInfo?.message },
    {
      label: "Preferable Date",
      value: viewDetailsInfo?.prefered_date
        ? dayjs(viewDetailsInfo.prefered_date).format(DATE_FORMAT.DD_MMM_YYYY)
        : "",
    },
    {
      label: "Preferable Time",
      value: viewDetailsInfo?.prefered_time
        ? dayjs(viewDetailsInfo.prefered_time, "HH:mm").format("hh:mm A")
        : "",
    },
  ];

  return (
    <CustomDrawer
      title={"Contact Query Details"}
      open={open}
      onClose={onClose}
      footer={null}
      width={500}
      className={styles.drawer}
    >
      <div className={styles.detailsContainer}>
        <Row gutter={[0, 8]}>
          {details.map((item, index) => (
            <Col span={24} key={index}>
              <p className={styles.detailItem}>
                <span className={styles.detailLabel}>{item.label}</span>{" - "}
                <span className={styles.detailValue}>
                  {item.value ? item.value : "NA"}
                </span>
              </p>
            </Col>
          ))}
        </Row>
      </div>
    </CustomDrawer>
  );
};

export default ContactQueriesDrawer;
